/* eslint-disable camelcase */
import i18n from 'src/i18n.js';
const t = (key) => i18n.t(key);
const sendUsageReportOptions = () => ({
    usagePricingRadio: [
        {
            label: t('orders.reportsAndInvoice.sendUsageReport.withprice'),
            value: 'withPrice',
        },
        {
            label: t('orders.reportsAndInvoice.sendUsageReport.withoutprice'),
            value: 'withoutPrice',
        },
    ],
    email_fax: [
        { label: t('physicians.physicianDetailCard.email'), value: 'isEmail' },
        { label: t('physicians.physicianDetailCard.fax'), value: 'isFax' },
    ],
    reportOption: [
        {
            label: t('orders.reportsAndInvoice.sendUsageReport.singlereport'),
            value: 'combined',
        },
        {
            label: t('orders.reportsAndInvoice.sendUsageReport.tworeports'),
            value: 'separate',
        },
        {
            label: t(
                'orders.reportsAndInvoice.sendUsageReport.nonTissuereport'
            ),
            value: 'nonTissue',
        },
        {
            label: t('orders.reportsAndInvoice.sendUsageReport.tissuereport'),
            value: 'tissue',
        },
    ],
    discrepancyOption: [
        {
            label: t(
                'orders.reportsAndInvoice.sendUsageReport.DiscrepancyReport'
            ),
            value: 'USAGE_DISCREPANCY_REPORT',
        },
    ],
});
export default sendUsageReportOptions;
